// @ts-check
import { initSchema } from '@aws-amplify/datastore';
import { schema } from './schema';

const Currency = {
  "SGD": "SGD",
  "USD": "USD"
};

const PollStatus = {
  "CREATED": "CREATED",
  "SWING": "SWING",
  "PLEDGING1": "PLEDGING1",
  "PLEDGING2": "PLEDGING2",
  "END": "END",
  "CLOSED": "CLOSED"
};

const VoteType = {
  "VOTE": "VOTE",
  "WITHDRAW": "WITHDRAW"
};

const UserType = {
  "INDIVIDUAL": "INDIVIDUAL",
  "PAID": "PAID",
  "COMPANY": "COMPANY",
  "ADMINISTRATOR": "ADMINISTRATOR",
  "REPRESENTATIVE": "REPRESENTATIVE",
  "PROXY": "PROXY",
  "STAFF": "STAFF"
};

const Tier = {
  "FREE": "FREE",
  "STANDARD": "STANDARD",
  "ENTERPRISE": "ENTERPRISE",
  "CONSULTATIVE": "CONSULTATIVE"
};

const CompanyStatus = {
  "ACTIVATED": "ACTIVATED",
  "DEACTIVATED": "DEACTIVATED"
};

const HotPollStatus = {
  "VISIBLE": "VISIBLE",
  "HIDDEN": "HIDDEN"
};

const PledgeType = {
  "PLEDGE": "PLEDGE",
  "WITHDRAW": "WITHDRAW"
};

const CompanyRole = {
  "ADMIN": "ADMIN",
  "REPRESENTATIVE": "REPRESENTATIVE",
  "PROXY": "PROXY",
  "EMPLOYEE": "EMPLOYEE"
};

const RequestJoinCompanyStatus = {
  "PENDING": "PENDING",
  "APPROVED": "APPROVED",
  "REJECTED": "REJECTED"
};

const AlertType = {
  "POLL_RESET": "POLL_RESET",
  "POLL_END": "POLL_END",
  "POLL_VOTE_CLOSED": "POLL_VOTE_CLOSED",
  "POLL_PLEDGING_CLOSED": "POLL_PLEDGING_CLOSED",
  "POLL_PLEDGING1": "POLL_PLEDGING1",
  "POLL_PLEDGING2": "POLL_PLEDGING2"
};

const PaymentType = {
  "PLEDGE_1": "PLEDGE_1",
  "PLEDGE_2": "PLEDGE_2",
  "PLEDGE_OUT": "PLEDGE_OUT"
};

const StripeChargeStatus = {
  "UNPAID": "UNPAID",
  "PAID": "PAID",
  "REFUNDED": "REFUNDED"
};

const { Poll, VoteResult, Vote, User, Company, SubPoll, HotPoll, HotPledge, Pledge, PledgeResult, PollReport, PackageSubscription, CompanyUser, CompanyDomain, RequestJoinCompany, PaymentProvider, PaymentCustomer, PaymentTransaction, Alert, StripeAccount, StripeCustomer, Payment, StripeCharge, StripeSubscription, ProxyPoll, DefaultConfiguration, CustomConfiguration, PollCount, Detail, S3Object, PollOption, OrganisationInfo, PaymentData } = initSchema(schema);

export {
  Poll,
  VoteResult,
  Vote,
  User,
  Company,
  SubPoll,
  HotPoll,
  HotPledge,
  Pledge,
  PledgeResult,
  PollReport,
  PackageSubscription,
  CompanyUser,
  CompanyDomain,
  RequestJoinCompany,
  PaymentProvider,
  PaymentCustomer,
  PaymentTransaction,
  Alert,
  StripeAccount,
  StripeCustomer,
  Payment,
  StripeCharge,
  StripeSubscription,
  ProxyPoll,
  DefaultConfiguration,
  CustomConfiguration,
  PollCount,
  Currency,
  PollStatus,
  VoteType,
  UserType,
  Tier,
  CompanyStatus,
  HotPollStatus,
  PledgeType,
  CompanyRole,
  RequestJoinCompanyStatus,
  AlertType,
  PaymentType,
  StripeChargeStatus,
  Detail,
  S3Object,
  PollOption,
  OrganisationInfo,
  PaymentData
};